
























































import SheetResult from "./SheetResult.vue";
import WtHttp from "@/components/WtHttp";
import {
  Component,
  Prop,
  Vue,
  Watch,
  SaitenState,
  ConstsState
} from "division-marker";

var Loading = require("vue-loading-overlay");

@Component({ components: { SheetResult }, mixins: [] })
export default class BranchResults extends Vue {
  subject_id = "";
  students: any[] = [];
  sheets: any[] = [];
  activities: any[] = [];

  loaded = false;
  new_student_id = "";

  get state(): SaitenState {
    return this.$store.state.saiten;
  }
  get const_state(): ConstsState {
    return this.$store.state.consts;
  }
  get subject_names() {
    return this.const_state.subject_names;
  }

  mounted() {
    this.subject_id = "29";
  }
  async load() {
    if (this.subject_id == "") {
      this.loaded = false;
      return;
    }
    const res = await WtHttp.get(`./api/branches/results/${this.subject_id}`);
    let sheets = res.data.sheets;
    console.log(sheets);
    this.sheets = sheets;
    this.students = res.data.students;
    this.activities = res.data.activities;
    this.loaded = true;
  }
  activity(sheet_id: number, student_id: string) {
    return this.activities.find(
      a => a.sheet_id == sheet_id && a.student_id == student_id
    );
  }
  reset_password(user: any) {
    if (
      window.confirm(
        "パスワードを学籍番号と同じ値に初期化します。よろしいですか？"
      )
    ) {
      console.log({ user_id: user.user_id });
      WtHttp.post("./api/study/reset_password", { user_id: user.user_id }).then(
        res => {
          user.password_completed = false;
        },
        error => {
          alert("パスワードリセットに失敗しました");
        }
      );
    }
  }

  //生徒追加
  async add_student() {
    try {
      const res = await WtHttp.post(`./api/branches/add_student`, {
        student_id: this.new_student_id
      });
      console.log(res);
      if (res.data.result == "ok") {
        alert("登録が完了しました。");
        this.new_student_id = "";
        this.load();
      } else {
        alert(res.data.message);
      }
    } catch (err) {
      alert("登録処理に失敗しました。");
    }
  }

  async deleted_changed(user: any) {
    const res = await WtHttp.post("./api/study/deleted", {
      user_id: user.id,
      deleted: user.deleted
    });
  }

  @Watch("subject_id")
  subject_id_changed(to: any) {
    this.load();
  }
}
